import PropTypes from 'prop-types';
import React from 'react';
import styles from './styles.module.scss';
import { Image, Row, Col} from 'react-bootstrap';
import FreshsalesIcon from 'src/legacy/images/freshsales_icon.png';
import FreshsalesConfigurationPage from './FreshsalesConfigurationPage';
import DeactivateIntegrationContainer from 'src/legacy/components/DeactivateIntegration/index';
import LoadingMessage from 'src/legacy/components/LoadingMessage';
import BackButton from 'src/legacy/components/BackButton';
import HelpIcon from 'src/legacy/images/help-icon.png';
import { shouldFetchIntegrations } from 'src/legacy/services/utils';
import { localizedStrings } from 'src/localization/index.jsx';

class FreshsalesView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      deleteConfirmation: false,
      showOnboarding: false
    };

    this._handleDeactivateClicked = this._handleDeactivateClicked.bind(this);
    this._handleToggleOnboarding = this._handleToggleOnboarding.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedFreshSales = localizedStrings.components.integrations.freshsales;
    this.localizedCommons = localizedStrings.commons;
    this.localizedIntgerationActions = localizedStrings.components.integrations.actions;
  }

  componentDidMount() {
    if(shouldFetchIntegrations(this.props.integrations)) {
      this.props.fetchIntegrations();
    }
    this.props.fetchFreshsalesIntegration();
  }

  _handleDeactivateClicked(){
    this.setState({
      deleteConfirmation: true
    })
  }

  _handleToggleOnboarding() {
    this.setState({
      showOnboarding: !this.state.showOnboarding
    })
  }

  render(){
    if (this.props.loading) {
      return this._renderLoadingMessage();
    }

    return (
      <div className={styles.content} fluid>
        <Row className={styles.row}>
          <Col md={3} className={styles.left}>
            
            <BackButton className={styles.back} title={ this.localizedCommons.actions.back } onClick={() => {
              this.props.handleIntegrationsBackButton();
            }} />

            <div className={ styles.heading }>
              <Image src={FreshsalesIcon} />
              <h2 className={styles.name}>{ this.localizedFreshSales.title }</h2>
              <p className={styles.description}>{ this.localizedFreshSales.sub_text }</p>
              {this.props.integration && this.props.integration.state.code === "ok" &&
                <button className={styles.button}  disabled={this.props.deactivating} onClick={this._handleDeactivateClicked}>
                      {this.props.deactivating && `${this.localizedIntgerationActions.deactivating}...`}
                      {!this.props.deactivating && this.localizedIntgerationActions.deactivate }
                </button>
              }
            </div>
            {!this.state.showOnboarding &&  
            <div className={styles.helpDiv} onClick={this._handleToggleOnboarding}>
              <Image src={HelpIcon} className={styles.helpIcon}/>
              <div className={styles.helpSection}>
              <p className={styles.helpSectionTitle}>{ this.localizedFreshSales.help_text.title }?</p>
              <p className={styles.helpSectionText}>{ this.localizedFreshSales.help_text.sub_text }</p>
              </div>
            </div>}

          </Col>
          <Col md={9} className={styles.right}>
            <FreshsalesConfigurationPage store={this.context.store} 
              showOnboarding={this.state.showOnboarding}
              toggleOnboarding={this._handleToggleOnboarding}/>
          </Col>
        </Row>
        <DeactivateIntegrationContainer 
           name = {this.localizedFreshSales.title}
           type="freshsales"
           message= { this.localizedFreshSales.details.deactivate.sub_text }
           show={this.state.deleteConfirmation}
           onCancel={()=> {
            this.setState({
               deleteConfirmation: false
           })
           }}
         />
      </div>
    );
  }

  _renderLoadingMessage() {
    return (
      <LoadingMessage
        className={styles.loadingMessage}
        message={`${this.localizedFreshSales.loading}...`}
        visible={this.props.loading}
      />
    )
  }
}

export default FreshsalesView;